exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.avatar__image{width:100%;max-width:100px;height:auto}@media (min-width:460px){.avatar__image{max-width:115px}}.avatar__upload{padding-left:30px}.avatar__text{margin:0 0 10px;color:#7f7f7f;font-size:16px;line-height:1.3}@media (min-width:460px){.avatar__text{margin-bottom:16px;font-size:16px}}.avatar__upload-input{display:none}.avatar__upload-link{color:#ec2027;font-size:16px;text-decoration:underline}.avatar__skip{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-rules-2!./node_modules/postcss-loader/lib??ref--3-rules-3!./node_modules/sass-loader/lib/loader.js??ref--3-rules-4!./src/routes/client/site/auth/avatar/Avatar.scss
// module id = 1858
// module chunks = 1